import MuiPopper, { PopperPlacementType } from '@mui/material/Popper';
import Fade from '@mui/material/Fade';
import { IconButton, Paper } from '@mui/material';
import { ReactNode, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';

interface PopperProps {
    isOpen: boolean;
    anchorEl: HTMLButtonElement | null;
    placement?: PopperPlacementType;
    children: ReactNode;
    onClose?: () => void;
}

export default function Popper({ isOpen, children, anchorEl, placement, onClose }: PopperProps) {

    return (
        <MuiPopper
            sx={{ zIndex: 1200 }}
            open={isOpen}
            anchorEl={anchorEl}
            placement={placement}
            transition
        >
            {({ TransitionProps }) => (
              <Fade {...TransitionProps} timeout={350}>
                <Paper elevation={3} sx={{ p: 2, pr: 3, position: 'relative' }}>
                  {children}
                  <IconButton
                    onClick={onClose}
                    sx={{ p: 0, marginLeft: '5px', position: 'fixed', top: '8px' }}
                >
                    <CloseIcon sx={{ fontSize: '12px' }} />
                </IconButton>
                </Paper>
              </Fade>
            )}
        </MuiPopper>
    );
}